import { AsyncIterableX } from '@reactivex/ix-esnext-esm/asynciterable/asynciterablex';
import { concat } from '@reactivex/ix-esnext-esm/asynciterable/concat';
import { map } from '@reactivex/ix-esnext-esm/asynciterable/pipe/map';
import { InvalidStorageStackItemIteratorError } from './errors';
import { StackItemEnumerator } from './StackItemEnumerator';
export class StackItemIterator extends StackItemEnumerator {
    key() {
        const { mutableCurrent } = this;
        if (mutableCurrent === undefined) {
            throw new InvalidStorageStackItemIteratorError();
        }
        return mutableCurrent.key;
    }
    keys() {
        const iterable = AsyncIterableX.from(this.enumerator).pipe(map(({ key }) => ({ value: key })));
        return new StackItemEnumerator(iterable[Symbol.asyncIterator]());
    }
    values() {
        const iterable = AsyncIterableX.from(this.enumerator).pipe(map(({ value }) => ({ value })));
        return new StackItemEnumerator(iterable[Symbol.asyncIterator]());
    }
    concatIterator(other) {
        const iterable = concat(AsyncIterableX.from(this.enumerator), AsyncIterableX.from(other.enumerator));
        return new StackItemIterator(iterable[Symbol.asyncIterator]());
    }
}

//# sourceMappingURL=StackItemIterator.js.map
